export function groupByAuthor(array, string) {
  if (string == ' ' || string == 'Filter by Author') {
    return array;
  } else {
    return array.filter(item => item.node.author.name === string);
  }
}